import React from 'react'
import Autosuggest from 'react-autosuggest'
import PropTypes from 'prop-types'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'

require('./identificator.css')
require('./search.css')

const cityQuarters = require('./data/gemeindeverzeichnis.json')
const landIcon = require('./img/icon-land.svg')
const stadtIcon = require('./img/icon-stadt.svg')
// console.log(cityQuarters)

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  const inputValue = value.trim().toLowerCase()
  const inputLength = inputValue.length

  return inputLength === 0
    ? []
    : cityQuarters.filter(
      lang =>
        lang.ORTNAME.toLowerCase().slice(0, inputLength) === inputValue ||
          lang.PLZ4.toString()
            .toLowerCase()
            .slice(0, inputLength) === inputValue
    )
}

// When suggestion is clicked, Autosuggest needs to populate the input element
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion =>
  suggestion.PLZ4 + ' ' + suggestion.ORTNAME

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>{`${suggestion.PLZ4} ${suggestion.ORTNAME}`}</div>
)

const textElements = {
  'ist': 'ist eine ',
  'iststadt': 'ist eine der zehn grössten'
}

class Identificator extends React.Component {
  constructor (props) {
    super(props)

    this.selectedOnList = this.selectedOnList.bind(this)

    this.state = {
      showMessageIfNotCitizen: false,
      isLoading: false,
      suggestions: [],
      value: '',
      selectedQuarter: ''
    }
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    })
  }

  selectedOnList (quarter, circle) {
    let suggestion = {
      circle: 'Kreis ' + circle,
      name: quarter
    }

    // console.log(suggestion);

    this.setState({
      selectedQuarter: suggestion
    })

    window.scrollTo(0, window.innerHeight)

    // console.log(window.innerHeight+'px')

    this.props.clickHandler(suggestion, true, true)
  }

  onSuggestionSelected = (event, { suggestion }) => {
    this.setState({
      selectedQuarter: suggestion,
      readerMadeHisChoice: true
    })

    // console.log(suggestion)

    this.props.clickHandler(suggestion, true, true)
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value)
    })
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    })
    // this.props.clickHandler(this.state.value,true,true)
  }

  resetSelection = () => {
    this.setState({
      selectedQuarter: '',
      value: ''
    })
    // suggestion => suggestion.name + ' (' + suggestion.circle + ')';
    this.props.clickHandler('', true, false)
  }

  render () {
    const { value, suggestions } = this.state

    // Autosuggest will pass through all these props to the input element.
    const inputProps = {
      placeholder: 'PLZ/Ort',
      value,
      onChange: this.onChange,
      type: 'search'
    }

    return (
      <div className='identificator wrapper'>
        <div className='ui vertical very fitted segment text-center'>
          <div className='ui message identificator'>
            {/*
            <p className='identificator question title'>
              In welcher Region leben Sie?
            </p>
            <button
              className={`ui green basic large button ${
                this.props.readerIsCityCitizen ? 'active' : ''
              }`}
              onClick={() =>
                this.props.clickHandler('', true, !!this.state.selectedQuarter)
              }
            >
              Ja
            </button>
            <button
              className={`ui red basic large button ${
                !this.props.readerIsCityCitizen &&
                this.props.readerMadeHisChoice
                  ? 'active'
                  : ''
              }`}
              onClick={() => this.props.clickHandler('', false, true)}
            >
              Nein
            </button>
            */}

            {!this.props.readerIsCityCitizen &&
              this.props.readerMadeHisChoice && (
                <p>
                  <i className='icon info circle' /> Sie sehen eine allgemeine
                  Version des Textes. Einzig einige Daten auf Quartierniveau
                  werden im Text nicht eingeblendet.
                </p>
              )}

            {this.props.readerIsCityCitizen && (
              <div>
                {this.props.readerMadeHisChoice === false && (
                  <p
                    className='search-label'
                    style={{
                      fontSize: '0.9em',
                      color: 'grey'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '1.2em',
                        color: 'black'
                      }}
                    >
                      Zu welchem Siedlungstyp gehört <strong>Ihre Gemeinde</strong>?
                    </span>
                  </p>
                )}

                {this.props.readerMadeHisChoice === true && <br />}
                <div className='ui large icon input'>
                  {/* <input type='text' placeholder='Quartier suchen...'></input> */}

                  {this.state.selectedQuarter === '' && (
                    <Autosuggest
                      suggestions={suggestions}
                      onSuggestionsFetchRequested={
                        this.onSuggestionsFetchRequested
                      }
                      onSuggestionsClearRequested={
                        this.onSuggestionsClearRequested
                      }
                      getSuggestionValue={getSuggestionValue}
                      renderSuggestion={renderSuggestion}
                      inputProps={inputProps}
                      onSuggestionSelected={this.onSuggestionSelected}
                      focusFirstSuggestion
                    />
                  )}
                </div>

                {this.state.selectedQuarter && (
                  <div className='selection reset box'>
                    <p>
                      <i
                        className='icon remove circle blue'
                        onClick={this.resetSelection}
                      />
                      <div className='region-icon' style={{backgroundImage:
                        this.state.selectedQuarter.SIEDLUNGSTYP.toLowerCase() === 'stadt' ? `url(${stadtIcon})`
                          : this.state.selectedQuarter.SIEDLUNGSTYP.toLowerCase() === 'städtisch' ? `url(${stadtIcon})`
                            : `url(${landIcon})`}} />
                      <span
                      ><strong>{ this.state.selectedQuarter.ORTNAME !== this.state.selectedQuarter.GDENAMK ? this.state.selectedQuarter.ORTNAME + ' (Gemeinde ' + this.state.selectedQuarter.GDENAMK + ')' : this.state.selectedQuarter.ORTNAME }</strong>
                        {' '}{ this.state.selectedQuarter.SIEDLUNGSTYP.toLowerCase() === 'stadt' ? textElements['iststadt'] : textElements['ist'] } <span className={`${this.state.selectedQuarter.SIEDLUNGSTYP.toLowerCase()} your-region`}>{this.state.selectedQuarter.SYNOPSIS}</span> {this.state.selectedQuarter.DETAIL}
                      </span>
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

Identificator.defaultProps = {}

Identificator.propTypes = {
  readerIsCityCitizen: PropTypes.bool,
  clickHandler: PropTypes.func,
  readerMadeHisChoice: PropTypes.bool
  /*
  onSuggestionSelected: PropTypes.func,
  changeChosenQuarter: PropTypes.func
  */
}

export default Identificator
